import React from "react";
import { List, Text } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
export default function KeywordSubmitSummary({ results = {} }) {
  const { t } = useTranslation();
  const { results: resultItems } = results;

  return (
    <>
      {results.alt_message && <Text mt="lg">{results.alt_message}</Text>}
      {resultItems && resultItems.length > 0 && (
        <>
          <List mt="sm">
            {resultItems.map((result, i) => (
              <List.Item
                key={i}
                icon={
                  result.success ? (
                    <IconCheck color="green" />
                  ) : (
                    <IconX color="red" />
                  )
                }
              >
                {result.success ? (
                  <span>
                    <>
                      {result.custom ? (
                        <>{result.message}</>
                      ) : (
                        <>
                          {result.keyword_claim_count ? (
                            <>
                              {t("user_app:keyword_claim_success_message", {
                                keyword_claim_count: result.keyword_claim_count,
                                name: result.name,
                              })}
                            </>
                          ) : (
                            <>
                              {t("user_app:keyword_entry_success_message", {
                                entry_count: result.entry_count,
                                entry_count_text:
                                  result.entry_count === 1
                                    ? t("mixer:entry_singular")
                                    : t("mixer:entry_plural"),
                                name: result.name,
                                current_entry_total: result.current_entry_total,
                                possible_entries: result.possible_entries,
                              })}
                            </>
                          )}
                        </>
                      )}
                    </>
                  </span>
                ) : (
                  <span>
                    {result.custom ? (
                      <>{result.message}</>
                    ) : (
                      <>
                        {result.message} {t("common:for")} <b>{result.name}</b>
                      </>
                    )}
                  </span>
                )}
              </List.Item>
            ))}
          </List>
        </>
      )}
    </>
  );
}
